import { Name } from './Name'
import { Person } from './Person'
import type { ISupplierContact } from '~/types/contact/models'
import {
  ContactTypeIds,
  getContactTypeById,
} from '~/services/selectLists/contactTypes'

export function SupplierContact(o: ISupplierContact): ISupplierContact {
  const fn = '[cynqueModules/dataObjects/SupplierContact.ts] Contact |'
  if (!o) {
    throw new Error(`${fn} SupplierContact called with falsey supplierContact`)
  }
  if (!o.person) {
    throw new Error(
      `${fn} SupplierContact called with falsey supplierContact.person`
    )
  }
  if (!o.supplier) {
    throw new Error(
      `${fn} No supplier object in supplierContact.` +
        ' This is almost certainly a programming error.'
    )
  }
  const obj = { ...o }
  obj.person = Person(o.person)
  obj.avatar = {
    descr: obj.person.name.initials ?? '',
    type: 'supplierContact',
  }
  const nameDescr = Name(o.person.name).descr ?? 'No Name'
  obj.label = nameDescr
  obj.descr = nameDescr + '\n' + (o.phone ?? o.person.phone ?? 'No Phone')
  obj.type = getContactTypeById(ContactTypeIds.SUPPLIER)
  obj.parentName = o.supplier.label
  obj.namePlusBiz =
    `${nameDescr} - ${obj.parentName} - ` +
    +(o.phone ?? o.person.phone ?? 'No Phone')
  obj.namePlusRole = `${nameDescr} - ${obj.role?.label ?? 'No role'}`

  console.debug(`${fn} returning`, obj)
  return obj
}
